export enum AuthType {
    Registration,
    Login,
    ForgotPassword,
    RestorePassword
}